import { RawAudioFormat } from '@mimir/common/transcoding/rawFrame';
import type { FieldOrder, PixelFormat, Resolution } from '@mimir/common/transcoding/types';
import type { Fraction } from '@mimir/common/util/fractionType';

export interface TestPacketHeaderVideo {
  type: 'video',
  keyFrame: boolean,
  frameRate: Fraction,
  resolution: Resolution,
  pixelFormat: PixelFormat,
  fieldOrder: FieldOrder,
}

export interface TestPacketHeaderAudio {
  type: 'audio',
  sampleCount: number,
  channelCount: number,
  sampleRate: number,
  format: RawAudioFormat,
}

export type TestPacketHeader = TestPacketHeaderVideo | TestPacketHeaderAudio;

export interface TestPacket {
  header: TestPacketHeader,
  payload: Uint8Array,
}

export function encodeTestPacket(testPacket: TestPacket): Uint8Array {
  const textEncoder = new TextEncoder();
  const headerString = JSON.stringify(testPacket.header);
  const headerBytes = textEncoder.encode(headerString);
  const payload = new Uint8Array(2 + headerBytes.length + testPacket.payload.length);
    // eslint-disable-next-line no-bitwise
  payload[0] = headerBytes.length & 0xFF;
    // eslint-disable-next-line no-bitwise
  payload[1] = (headerBytes.length >> 8) & 0xFF;
  payload.set(headerBytes, 2);
  payload.set(testPacket.payload, 2 + headerBytes.length);
  return payload;
}

export function decodeTestPacket(bytes: Uint8Array): TestPacket {
    // eslint-disable-next-line no-bitwise
  const headerByteCount = bytes[0] | (bytes[1] << 8);
  const textDecoder = new TextDecoder();
  const headerString = textDecoder.decode(bytes.slice(2, 2 + headerByteCount));
  const header : TestPacketHeader = JSON.parse(headerString);
  const payload = bytes.slice(2 + headerByteCount);
  return { header, payload };
}



